import { Injectable } from "@angular/core";
import { StockAlertGateway } from "../gateway/StockAlertGateway";
import { HttpClient } from "@angular/common/http";
import { StockAlert } from "src/app/domain/models/StockAlert";
import { Routes } from "src/app/infrastructure/routes";
import { Observable } from "rxjs";

@Injectable({providedIn: 'root'})
export class StockAlertService extends StockAlertGateway {

  constructor(private _http: HttpClient)
  {
    super()
  }

  getStockAlert(stockId: number): Observable<StockAlert[]>
  {
    return this._http.get<StockAlert[]>(Routes.StockAlertApi + '/GetStockAlert', {params: {stockId}})
  }

  update(stockAlertGuid: string, review: boolean): Observable<any>
  {
    return this._http.put<any>(Routes.StockAlertApi + '/Update', {stockAlertGuid, review })
  }

}
